import React from 'react';
import { CssBaseline } from "@mui/material";
import DashboardPage from './pages/DashboardPage';

function App() {
  return (
    <>
      <CssBaseline />
      <DashboardPage />
    </>
  );
}

export default App;
